import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { DialogsService } from 'src/app/custom-material/Services';
import { ApiService } from '../../../custom-material/Services/api.service';
import { BuildingModel, UserModel } from '../../Models';
import { globalData } from '../../Models/global.model';

@Component({
  selector: 'main-header',
  templateUrl: './t_header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  get userIsConnected(): boolean
  {
    return this.apiService.isConnected();
  }

  get user(): UserModel
  {
    return this.gd.connectedUser;
  }

  get building(): BuildingModel
  {
    return this.gd.headerBuilding;
  }

  get lang() {
    return this.translocoService.getActiveLang();
  }
  set lang(l) {
    this.translocoService.setActiveLang(l);
    localStorage.setItem('lang', l);
  }

  constructor(
    private apiService: ApiService,
    private router: Router,
    public gd: globalData,
    private translocoService: TranslocoService,
    private dialog:DialogsService
    ) { }

  ngOnInit() {
    let storageLang = localStorage.getItem('lang');
    if(storageLang) this.lang = storageLang;
  }

  exit() {
    let message = this.translocoService.translate('exit-confirm-message');
    this.dialog.confirm(message)
    .subscribe(confirm=> {
      if(confirm) {
        this.router.navigateByUrl('/').then( ()=> {
          this.apiService.exit();
        });
      }
    });
  }
}
